import React, {useState} from 'react';
import PropTypes from 'prop-types'

/* Utils */
import {
    useTheme,
    Box,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    RangeSlider,
    RangeSliderTrack,
    RangeSliderFilledTrack,
    RangeSliderThumb
} from '@chakra-ui/react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';

/* Constants */
const DEFAULT_VALUE = 3;

// Bazaarvoice returns the fit-scale tick labels in English (e.g. "Runs Small",
// "True to size", "Runs Large"). Map the known labels to our localized ids so
// the FR/CA storefront shows French; anything unrecognized falls back to the
// API label as-is.
const messages = defineMessages({
    runsSmall: {defaultMessage: 'Runs Small', id: 'pdp_reviews.actual_fit.runs_small'},
    trueToSize: {defaultMessage: 'True to size', id: 'pdp_reviews.actual_fit.true_to_size'},
    runsLarge: {defaultMessage: 'Runs Large', id: 'pdp_reviews.actual_fit.runs_large'}
})

const FIT_LABEL_MESSAGES = {
    'run small': messages.runsSmall,
    'runs small': messages.runsSmall,
    'true to size': messages.trueToSize,
    'run large': messages.runsLarge,
    'runs large': messages.runsLarge
}

const getFitLabelMessage = (label) =>
    FIT_LABEL_MESSAGES[String(label ?? '').trim().toLowerCase()]

const FitSelector = ({ onFitChange, options }) => {
    const theme = useTheme()
    const {formatMessage} = useIntl()
    const [selectedFit, setSelectedFit] = useState([DEFAULT_VALUE]);

    const handleOnChange = (selectedFitValue) => {
        setSelectedFit(selectedFitValue);

        if (onFitChange) {
            onFitChange(selectedFitValue);
        }
    }

    return (
        <Box>
            {options?.length > 0 &&
            (<>
                <Text {...theme.components.WriteReview.fieldTitle} mt={8}>
                    <FormattedMessage
                        defaultMessage="Actual Fit *"
                        id="pdp_reviews.write.actual.fit"
                    />
                </Text>
                <Box position="relative" width="100%">
                    <RangeSlider defaultValue={[DEFAULT_VALUE]}
                        min={1}
                        max={options.length}
                        step={1}
                        py={3}
                        onChangeEnd={handleOnChange}>
                        <RangeSliderTrack boxSize={'1px'} bg='webTypo.textStrikethrough'>
                            <RangeSliderFilledTrack bg='webTypo.textPrimary' />
                        </RangeSliderTrack>
                        <RangeSliderThumb boxSize={'12px'} index={0} bg='webTypo.textPrimary' />
                    </RangeSlider>
                    <Box display="flex" justifyContent="space-between">
                        {options.map((option, index) => {
                            const labelMessage = getFitLabelMessage(option?.Label)
                            return (
                                (index === 0 || index === 2 || index === options.length - 1) && (
                                    <Text
                                        key={index}
                                        textStyle={'bodyXsRegular'}
                                    >
                                        {labelMessage ? formatMessage(labelMessage) : option.Label}
                                    </Text>
                                )
                            )
                        })}
                    </Box>
                </Box>
            </>)
            }
        </Box>
    );
};

FitSelector.propTypes = {
    onFitChange: PropTypes.func,
    options: PropTypes.array.isRequired
};

export default FitSelector;
